// API Configuration
export const API_CONFIG = {
    BASE_URL: import.meta.env.VITE_API_BASE_URL,
};
// Headers for development (ngrok)
export const NGROK_HEADERS = {
    'ngrok-skip-browser-warning': 'true',
};
